// Hand-maintained: every token in `src/tokens/config.ts` must have a matching
// entry here, grouped by `token.group` (lowercased). Enforced by tokens.pattern.test.ts.

import React from "react";

export type TokenParams = {
  [key: string]: React.ReactNode | string;
};

function resolvePlaceholders(template: string, params: TokenParams = {}): string {
  return template.replace(/{{(.*?)}}/g, (_, key) => {
    const value = params[key.trim()];
    return value !== undefined ? String(value) : '';
  });
}

export function createTokens(config: any) {
  return {
    label: {
      /**
       * Sign Up (String Version)
       * The name of the shop
       */
      asdfasdf: {
        string: (input?: { params?: { parameter1?: React.ReactNode | string, parameter2?: React.ReactNode | string }, fallback?: string }): string => {
          const template = config.asdfasdf;
          if (!template) {
            return input?.fallback || '';
          }
          return resolvePlaceholders(template, input?.params || {});
        },
        /**
         * Sign Up (ReactNode Version)
         * The name of the shop
         */
        node: (input?: { params?: { parameter1?: React.ReactNode | string, parameter2?: React.ReactNode | string }, fallback?: React.ReactNode }): React.ReactNode => {
          const template = config.asdfasdf;
          if (!template) {
            return input?.fallback || null;
          }
          return resolvePlaceholders(template, input?.params || {});
        },
      },
      /**
       * Sign Up (String Version)
       * The name of the shop
       */
      signUp: {
        string: (input: { params: { parameter1: React.ReactNode | string, parameter2: React.ReactNode | string }, fallback?: string }): string => {
          const template = config.signUp;
          if (!template) {
            return input?.fallback || '';
          }
          return resolvePlaceholders(template, input?.params || {});
        },
        /**
         * Sign Up (ReactNode Version)
         * The name of the shop
         */
        node: (input: { params: { parameter1: React.ReactNode | string, parameter2: React.ReactNode | string }, fallback?: React.ReactNode }): React.ReactNode => {
          const template = config.signUp;
          if (!template) {
            return input?.fallback || null;
          }
          return resolvePlaceholders(template, input?.params || {});
        },
      },
      /**
       * Test Tokee (String Version)
       * The name of the shop
       */
      testToke2n: {
        string: (input?: { params?: undefined, fallback?: string }): string => {
          const template = config.testToke2n;
          if (!template) {
            return input?.fallback || '';
          }
          return resolvePlaceholders(template, input?.params || {});
        },
        /**
         * Test Tokee (ReactNode Version)
         * The name of the shop
         */
        node: (input?: { params?: undefined, fallback?: React.ReactNode }): React.ReactNode => {
          const template = config.testToke2n;
          if (!template) {
            return input?.fallback || null;
          }
          return resolvePlaceholders(template, input?.params || {});
        },
      },
      /**
       * Test Tokee (String Version)
       * The name of the shop
       */
      testToken: {
        string: (input?: { params?: undefined, fallback?: string }): string => {
          const template = config.testToken;
          if (!template) {
            return input?.fallback || '';
          }
          return resolvePlaceholders(template, input?.params || {});
        },
        /**
         * Test Tokee (ReactNode Version)
         * The name of the shop
         */
        node: (input?: { params?: undefined, fallback?: React.ReactNode }): React.ReactNode => {
          const template = config.testToken;
          if (!template) {
            return input?.fallback || null;
          }
          return resolvePlaceholders(template, input?.params || {});
        },
      },
      /**
       * Shop Banner (String Version)
       * The banner of the shop
       */
      shopBanner: {
        string: (input: { params: { shopBanner: React.ReactNode | string }, fallback?: string }): string => {
          const template = config.shopBanner;
          if (!template) {
            return input?.fallback || '';
          }
          return resolvePlaceholders(template, input?.params || {});
        },
        /**
         * Shop Banner (ReactNode Version)
         * The banner of the shop
         */
        node: (input: { params: { shopBanner: React.ReactNode | string }, fallback?: React.ReactNode }): React.ReactNode => {
          const template = config.shopBanner;
          if (!template) {
            return input?.fallback || null;
          }
          return resolvePlaceholders(template, input?.params || {});
        },
      },
      /**
       * Shop Contact Email (String Version)
       * The contact email of the shop
       */
      shopContactEmail: {
        string: (input: { params: { shopContactEmail: React.ReactNode | string }, fallback?: string }): string => {
          const template = config.shopContactEmail;
          if (!template) {
            return input?.fallback || '';
          }
          return resolvePlaceholders(template, input?.params || {});
        },
        /**
         * Shop Contact Email (ReactNode Version)
         * The contact email of the shop
         */
        node: (input: { params: { shopContactEmail: React.ReactNode | string }, fallback?: React.ReactNode }): React.ReactNode => {
          const template = config.shopContactEmail;
          if (!template) {
            return input?.fallback || null;
          }
          return resolvePlaceholders(template, input?.params || {});
        },
      },
    },
    general: {
      /**
       * Shop Title (String Version)
       * The Title of the shop
       */
      shopTitle: {
        string: (input?: { params?: undefined, fallback?: string }): string => {
          const template = config.shopTitle;
          if (!template) {
            return input?.fallback || '';
          }
          return resolvePlaceholders(template, input?.params || {});
        },
        /**
         * Shop Title (ReactNode Version)
         * The Title of the shop
         */
        node: (input?: { params?: undefined, fallback?: React.ReactNode }): React.ReactNode => {
          const template = config.shopTitle;
          if (!template) {
            return input?.fallback || null;
          }
          return resolvePlaceholders(template, input?.params || {});
        },
      },
      /**
       * Shop Name (String Version)
       * The name of the shop
       */
      shopName: {
        string: (input?: { params?: undefined, fallback?: string }): string => {
          const template = config.shopName;
          if (!template) {
            return input?.fallback || '';
          }
          return resolvePlaceholders(template, input?.params || {});
        },
        /**
         * Shop Name (ReactNode Version)
         * The name of the shop
         */
        node: (input?: { params?: undefined, fallback?: React.ReactNode }): React.ReactNode => {
          const template = config.shopName;
          if (!template) {
            return input?.fallback || null;
          }
          return resolvePlaceholders(template, input?.params || {});
        },
      },
      /**
       * Shop Logo (String Version)
       * The logo of the shop
       */
      shopLogo: {
        string: (input?: { params?: undefined, fallback?: string }): string => {
          const template = config.shopLogo;
          if (!template) {
            return input?.fallback || '';
          }
          return resolvePlaceholders(template, input?.params || {});
        },
        /**
         * Shop Logo (ReactNode Version)
         * The logo of the shop
         */
        node: (input?: { params?: undefined, fallback?: React.ReactNode }): React.ReactNode => {
          const template = config.shopLogo;
          if (!template) {
            return input?.fallback || null;
          }
          return resolvePlaceholders(template, input?.params || {});
        },
      },
    },
    description: {
      /**
       * Shop Description (String Version)
       * The description of the shop
       */
      shopDescription: {
        string: (input?: { params?: undefined, fallback?: string }): string => {
          const template = config.shopDescription;
          if (!template) {
            return input?.fallback || '';
          }
          return resolvePlaceholders(template, input?.params || {});
        },
        /**
         * Shop Description (ReactNode Version)
         * The description of the shop
         */
        node: (input?: { params?: undefined, fallback?: React.ReactNode }): React.ReactNode => {
          const template = config.shopDescription;
          if (!template) {
            return input?.fallback || null;
          }
          return resolvePlaceholders(template, input?.params || {});
        },
      },
    },
  };
}
